const GEO_TO_DB_NAME = {
  Ghanzi: "Ghazni",
  Daykundi: "Dykundi",
  Jowzjan: "Jawzjan",
  Nimruz: "Nimroz",
  Nuristan: "Nooristan",
  Panjshir: "Panjsher",
  "Sar-e Pol": "Sar-e-Pul",
  Uruzgan: "Urozgan",
  Paktia: "Paktya",
}

export const METRIC_LABELS = {
  receipt: "Receipt",
  distribution: "Distribution",
  distributions: "Distribution",
  receipts: "Receipt",
}

export const normalizeGeoProvinceName = geoName => GEO_TO_DB_NAME[geoName] || geoName

export const loadAfghanistanMapGeoJson = async () => {
  const baseUrl = process.env.PUBLIC_URL || ""
  const response = await fetch(`${baseUrl}/geo/afghanistan-provinces.geojson`)

  if (!response.ok) {
    throw new Error(`GeoJSON load failed (${response.status})`)
  }

  const geoJson = await response.json()

  return {
    ...geoJson,
    features: geoJson.features.map(feature => ({
      ...feature,
      properties: {
        ...feature.properties,
        name: normalizeGeoProvinceName(feature.properties.shapeName),
      },
    })),
  }
}
